import { render, staticRenderFns } from "./itemReceived.vue?vue&type=template&id=30a99616"
import script from "./itemReceived.vue?vue&type=script&lang=js"
export * from "./itemReceived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports